import { render, staticRenderFns } from "./menu-info.vue?vue&type=template&id=53911bcc&scoped=true&"
import script from "./menu-info.vue?vue&type=script&lang=js&"
export * from "./menu-info.vue?vue&type=script&lang=js&"
import style0 from "./menu-info.vue?vue&type=style&index=0&id=53911bcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53911bcc",
  null
  
)

export default component.exports